import React from 'react';
import { merge } from './helpers.js';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_CheckboxWrapper__2TRJ-{position:relative;cursor:pointer;padding-left:27px;min-height:16px}.styles-module_CheckboxInput__3WXHJ{display:none}.styles-module_CheckboxLabel__2XggE{color:#757575;font-weight:400;margin-bottom:0;display:flex;justify-content:space-between;cursor:pointer;transition:all .15s ease-in}.styles-module_CheckboxLabel__2XggE:hover{opacity:.85}.styles-module_CheckboxLabel__2XggE:before{content:\"\";position:absolute;left:0;top:1px;height:15px;width:15px;border-radius:var(--border-radius-tiny);border:1px solid #757575;transition:all .15s ease-in}.styles-module_CheckboxLabelActive__7t8z0{color:var(--white)}.styles-module_CheckboxLabelActive__7t8z0:before{background-color:var(--color-primary);border-color:var(--color-primary)}.styles-module_CheckboxLabelChecked__2AQ9w:after{content:\"\";width:9px;height:6px;position:absolute;border-bottom:2px solid #fff;border-left:2px solid #fff;transform:rotate(315deg);left:3px;top:4px}.styles-module_CheckboxLabelSemiChecked__2TcC_:after{content:\"\";width:9px;position:absolute;border-bottom:2px solid #fff;left:3px;top:8px;transform:translateY(-25%)}";
var styles = {"CheckboxWrapper":"styles-module_CheckboxWrapper__2TRJ-","CheckboxInput":"styles-module_CheckboxInput__3WXHJ","CheckboxLabel":"styles-module_CheckboxLabel__2XggE","CheckboxLabelActive":"styles-module_CheckboxLabelActive__7t8z0","CheckboxLabelChecked":"styles-module_CheckboxLabelChecked__2AQ9w","CheckboxLabelSemiChecked":"styles-module_CheckboxLabelSemiChecked__2TcC_"};
styleInject(css_248z,{"insertAt":"top"});

var Checkbox = function (_a) {
    var checked = _a.checked, children = _a.children, id = _a.id, onChange = _a.onChange, semiChecked = _a.semiChecked, value = _a.value, className = _a.className, dataCy = _a.dataCy;
    return (React.createElement("div", { className: merge(styles.CheckboxWrapper, className) },
        React.createElement("input", { value: value, checked: checked, type: "checkbox", "data-cy": dataCy, onChange: function (event) { return onChange(event); }, id: id, className: styles.CheckboxInput }),
        React.createElement("label", { className: merge(styles.CheckboxLabel, (checked || semiChecked) && styles.CheckboxLabelActive, checked
                ? styles.CheckboxLabelChecked
                : semiChecked && styles.CheckboxLabelSemiChecked), htmlFor: id }, children)));
};
Checkbox.defaultProps = {
    children: null,
    semiChecked: false,
    value: '',
    className: '',
};

export { Checkbox };
